import { parseClientEnv, siteUrl, turnstileSiteKey } from '@inboxkit/env/sites';

const env = parseClientEnv(import.meta.env);

export const API_URL = siteUrl('api', { env });
export const APP_URL = siteUrl('app', { env });
export const MARKETING_URL = siteUrl('marketing', { env });
export const STATUS_URL = siteUrl('status', { env });
export const TURNSTILE_SITE_KEY = turnstileSiteKey(env);
